// Shopify Bulk Pricing Calculator - JavaScript
document.addEventListener('DOMContentLoaded', function() {
  // Debug flag - set to false to disable console logs
  const DEBUG = false;
  class BulkPricingCalculator {
    constructor() {
      // DOM Elements
      this.container = document.getElementById('bulk-pricing-calculator');
      if (!this.container) return;
      
      this.optionsContainer = document.getElementById('calculator-options');
      this.quantitySelect = document.getElementById('calculator-quantity');
      this.viewTiersButton = document.getElementById('calculator-view-tiers');
      this.activeDiscountsContainer = document.getElementById('calculator-active-discounts');
      this.priceBreakdownContainer = document.getElementById('calculator-price-breakdown');
      this.addToCartButton = document.getElementById('calculator-add-to-cart');
      this.getQuoteButton = document.getElementById('calculator-get-quote');
      
      // Modal Elements
      this.pricingModal = document.getElementById('calculator-pricing-modal');
      this.modalClose = document.getElementById('calculator-modal-close');
      this.modalTabs = document.querySelectorAll('.calculator-tab');
      this.tabContents = document.querySelectorAll('.calculator-tab-content');
      this.baseTiersBody = document.getElementById('calculator-base-tiers-body');
      this.addonTiersContainer = document.getElementById('calculator-addon-tiers');
      
      // Inquiry Modal Elements
      this.inquiryModal = document.getElementById('calculator-inquiry-modal');
      this.inquiryClose = document.getElementById('calculator-inquiry-close');
      this.inquiryForm = document.getElementById('calculator-inquiry-form');
      this.quantitySummary = document.getElementById('inquiry-quantity-summary');
      this.priceSummary = document.getElementById('inquiry-price-summary');
      
      // Product Data
      this.productId = this.container.dataset.productId;
      this.productTitle = this.container.dataset.productTitle;
      this.basePrice = parseFloat(this.container.dataset.basePrice) || 0;
      this.currency = this.container.dataset.currency || '$';
      
      // Product Metafields
      this.loadMetafields();
      
      // State
      this.selectedOptions = {};
      this.quantity = 1;
      this.pricing = null;
      
      // Initialize
      this.init();
    }
    
    loadMetafields() {
      // Product Metafields
      this.baseTiers = this.getMetafieldJson('pricing_calculator_base_tiers') || [];
      this.addons = this.getMetafieldJson('pricing_calculator_addons') || [];
      this.settings = this.getMetafieldJson('pricing_calculator_settings') || {};
    }
    
    // Get JSON from metafield
    getMetafieldJson(key) {
      try {
        // Check for data attributes on the container (from liquid)
        if (this.container.dataset[key]) {
          const rawData = this.container.dataset[key];
          
          // Handle empty strings or null values
          if (!rawData || rawData === 'null' || rawData === '[]' || rawData === '{}') {
            return null;
          }
          
          try {
            return JSON.parse(rawData);
          } catch (e) {
            console.error(`Error parsing ${key} from data attribute:`, e);
            return null;
          }
        }
        
        return null;
      } catch (error) {
        console.error(`Error accessing metafield ${key}:`, error);
        return null;
      }
    }
    
    init() {
      // Get settings or use defaults
      this.minQuantity = this.settings && this.settings.min_quantity ? parseInt(this.settings.min_quantity) : 1;
      
      // Set initial quantity to the MOQ, not just 1
      this.quantity = this.minQuantity;
      
      // Render options if we have addons
      if (this.addons && this.addons.length > 0) {
        this.renderOptions();
        
        // Set initial values
        this.initializeDefaultOptions();
      }
      
      // Initialize quantity input with MOQ
      if (this.quantitySelect) {
        this.quantitySelect.value = this.quantity;
        this.quantitySelect.min = 1; // Allow any value, validation handled separately
        
        // Show MOQ notice if there's a minimum
        if (this.minQuantity > 1) {
          const moqNotice = document.getElementById('calculator-moq-notice');
          const minQuantitySpan = document.getElementById('calculator-min-quantity');
          
          if (moqNotice && minQuantitySpan) {
            minQuantitySpan.textContent = this.formatNumber(this.minQuantity);
            moqNotice.classList.remove('hidden');
          }
          
          // Initial validation
          this.validateQuantity(this.quantity);
        }
      }
      
      // Calculate initial pricing
      this.calculatePricing();
      
      // Render price breakdown
      this.renderPriceBreakdown();
      
      // Event Listeners
      this.setupEventListeners();
      
      // Check if form was just submitted (success redirect)
      if (window.location.search.includes('contact_posted=true')) {
        if (DEBUG) {
          console.log('Contact form was successfully submitted!');
          console.log('Current URL:', window.location.href);
          console.log('Store domain:', window.location.hostname);
        }
        // Close the inquiry modal if it's open
        setTimeout(() => {
          this.closeInquiryModal();
          alert('Thank you! Your inquiry has been submitted successfully.');
        }, 500);
      }
    }
    

    
    renderOptions() {
      if (!this.addons || !this.addons.length) return;
      
      this.optionsContainer.innerHTML = '';
      
      this.addons.forEach(addon => {
        const optionElement = document.createElement('div');
        optionElement.className = 'calculator-option';
        
        const labelElement = document.createElement('label');
        labelElement.className = 'calculator-label';
        labelElement.textContent = addon.label;
        
        optionElement.appendChild(labelElement);
        
        if (addon.type === 'dropdown') {
          const selectElement = document.createElement('select');
          selectElement.className = 'calculator-select';
          selectElement.dataset.optionLabel = addon.label;
          
          addon.values.forEach(value => {
            const optionItem = document.createElement('option');
            optionItem.value = value.label;
            optionItem.textContent = value.label;
            
            if (value.price_addon > 0) {
              optionItem.textContent += ` (+${this.formatMoney(value.price_addon)})`;
            }
            
            selectElement.appendChild(optionItem);
          });
          
          selectElement.addEventListener('change', (e) => {
            this.handleOptionChange(addon.label, e.target.value);
          });
          
          optionElement.appendChild(selectElement);
        } else if (addon.type === 'radio') {
          const radioGroup = document.createElement('div');
          radioGroup.className = 'calculator-radio-group';
          
          addon.values.forEach((value, index) => {
            const radioOption = document.createElement('div');
            radioOption.className = 'calculator-radio-option';
            
            const radioInput = document.createElement('input');
            radioInput.type = 'radio';
            radioInput.className = 'calculator-radio-input';
            radioInput.name = `calculator-option-${addon.label}`;
            radioInput.id = `calculator-option-${addon.label}-${index}`;
            radioInput.value = value.label;
            
            const radioLabel = document.createElement('label');
            radioLabel.className = 'calculator-radio-label';
            radioLabel.htmlFor = `calculator-option-${addon.label}-${index}`;
            
            const labelText = document.createElement('span');
            labelText.textContent = value.label;
            
            radioLabel.appendChild(labelText);
            
            if (value.price_addon > 0) {
              const badgeElement = document.createElement('span');
              badgeElement.className = 'calculator-option-badge';
              badgeElement.textContent = `+${this.formatMoney(value.price_addon)}`;
              radioLabel.appendChild(badgeElement);
            }
            
            radioOption.appendChild(radioInput);
            radioOption.appendChild(radioLabel);
            
            radioInput.addEventListener('change', () => {
              if (radioInput.checked) {
                this.handleOptionChange(addon.label, value.label);
                
                // Update selected styling
                document.querySelectorAll(`input[name="${radioInput.name}"]`).forEach(input => {
                  input.closest('.calculator-radio-option').classList.remove('selected');
                });
                radioOption.classList.add('selected');
              }
            });
            
            radioGroup.appendChild(radioOption);
          });
          
          optionElement.appendChild(radioGroup);
        }
        
        this.optionsContainer.appendChild(optionElement);
      });
    }
    
    initializeDefaultOptions() {
      // Set default selections for all addons
      this.addons.forEach(addon => {
        if (addon.values && addon.values.length > 0) {
          this.selectedOptions[addon.label] = addon.values[0].label;
          
          // Set UI to match
          if (addon.type === 'dropdown') {
            const select = this.optionsContainer.querySelector(`select[data-option-label="${addon.label}"]`);
            if (select) select.value = addon.values[0].label;
          } else if (addon.type === 'radio') {
            const firstRadio = this.optionsContainer.querySelector(`input[name="calculator-option-${addon.label}"]`);
            if (firstRadio) {
              firstRadio.checked = true;
              firstRadio.closest('.calculator-radio-option').classList.add('selected');
            }
          }
        }
      });
    }
    
    handleOptionChange(optionLabel, value) {
      this.selectedOptions[optionLabel] = value;
      this.calculatePricing();
      this.renderPriceBreakdown();
      this.renderActiveDiscounts();
    }
    
    handleQuantityChange(value) {
      // Parse the value to an integer
      const newQuantity = parseInt(value);
      
      // Just update the quantity, don't force minimum
      if (isNaN(newQuantity)) {
        this.quantity = 1;
        // Update the input value if it was invalid
        if (this.quantitySelect) {
          this.quantitySelect.value = 1;
        }
      } else {
        this.quantity = newQuantity;
      }
      
      this.calculatePricing();
      this.renderPriceBreakdown();
      this.renderActiveDiscounts();
      
      // Update tier tables in modal if open
      if (this.pricingModal && !this.pricingModal.classList.contains('hidden')) {
        this.renderTierTables();
      }
    }
    
    validateQuantity(value) {
      // Get the MOQ notice element
      const moqNotice = document.getElementById('calculator-moq-notice');
      
      // Always ensure MOQ notice is showing if there's a minimum
      if (this.minQuantity > 1 && moqNotice) {
        moqNotice.classList.remove('hidden');
      }
      
      // Handle validation state
      if (value < this.minQuantity) {
        // Invalid state - below minimum
        if (this.quantitySelect) {
          this.quantitySelect.classList.add('invalid-quantity');
        }
        
        // Disable the Get Quote button
        if (this.getQuoteButton) {
          this.getQuoteButton.disabled = true;
          this.getQuoteButton.classList.add('calculator-button-disabled');
        }
        
        // Show error state in MOQ notice
        if (moqNotice) {
          moqNotice.classList.add('calculator-moq-error');
        }
        
        return false;
      } else {
        // Valid state - at or above minimum
        if (this.quantitySelect) {
          this.quantitySelect.classList.remove('invalid-quantity');
        }
        
        // Enable the Get Quote button
        if (this.getQuoteButton) {
          this.getQuoteButton.disabled = false;
          this.getQuoteButton.classList.remove('calculator-button-disabled');
        }
        
        // Remove error state from MOQ notice
        if (moqNotice) {
          moqNotice.classList.remove('calculator-moq-error');
        }
        
        return true;
      }
    }
    
    calculatePricing() {
      const findTier = (qty, tiers) => {
        if (!tiers || !tiers.length) return { type: 'none', value: 0 };
        
        // Modified to handle "no max price" - where max_qty is -1 or a very high value
        return tiers.find(t => qty >= t.min_qty && (t.max_qty === -1 || t.max_qty === 999999999 || qty <= t.max_qty)) || 
               { type: 'none', value: 0 };
      };
      
      const applyDiscount = (price, type, value) => {
        switch (type) {
          case 'percentage': return price * (1 - value / 100);
          case 'flat': return Math.max(price - value, 0);
          case 'fixed': return value;
          default: return price;
        }
      };
      
      // Calculate base price with tier
      const baseTier = findTier(this.quantity, this.baseTiers);
      const discountedBase = applyDiscount(this.basePrice, baseTier.type, baseTier.value);
      
      // Calculate each addon with its individual tier
      const addonBreakdown = [];
      let totalAddonPrice = 0;
      
      this.addons.forEach(addon => {
        const selectedValue = this.selectedOptions[addon.label];
        const optionValue = addon.values.find(v => v.label === selectedValue);
        
        if (optionValue && optionValue.price_addon > 0) {
          const addonTier = findTier(this.quantity, optionValue.price_tiers);
          const discountedAddon = applyDiscount(optionValue.price_addon, addonTier.type, addonTier.value);
          const savings = optionValue.price_addon - discountedAddon;
          
          addonBreakdown.push({
            optionLabel: addon.label,
            selectedValue,
            originalPrice: optionValue.price_addon,
            discountedPrice: discountedAddon,
            tier: addonTier,
            savings
          });
          
          totalAddonPrice += discountedAddon;
        }
      });
      
      const unitPrice = discountedBase + totalAddonPrice;
      const totalPrice = unitPrice * this.quantity;
      
      // Calculate original total and savings
      const originalAddonTotal = this.addons.reduce((total, addon) => {
        const selectedValue = this.selectedOptions[addon.label];
        const optionValue = addon.values.find(v => v.label === selectedValue);
        return total + (optionValue?.price_addon || 0);
      }, 0);
      
      const originalTotal = (this.basePrice + originalAddonTotal) * this.quantity;
      const savings = originalTotal - totalPrice;
      
      this.pricing = {
        unitPrice: parseFloat(unitPrice.toFixed(2)),
        totalPrice: parseFloat(totalPrice.toFixed(2)),
        originalTotal,
        savings,
        breakdown: {
          baseTier,
          discountedBase,
          addonBreakdown,
          totalAddonPrice
        }
      };
      
      return this.pricing;
    }
    
    renderPriceBreakdown() {
      if (!this.pricing) return;
      
      const { unitPrice, totalPrice, savings, breakdown } = this.pricing;
      
      let html = `
        <div class="calculator-price-line">
          <span>Base Price:</span>
          <span>${this.formatMoney(breakdown.discountedBase)}</span>
        </div>
      `;
      
      breakdown.addonBreakdown.forEach(addon => {
        html += `
          <div class="calculator-price-line">
            <span>${addon.selectedValue}:</span>
            <div>
              <span>${this.formatMoney(addon.discountedPrice)}</span>
              ${addon.savings > 0 ? `
                <div class="calculator-price-addon-savings">
                  (${this.formatMoney(addon.savings)} saved)
                </div>
              ` : ''}
            </div>
          </div>
        `;
      });
      
      html += `
        <div class="calculator-separator"></div>
        
        <div class="calculator-price-line unit-price">
          <span>Unit Price:</span>
          <span>${this.formatMoney(unitPrice)}</span>
        </div>
        
        <div class="calculator-price-line total-price">
          <span>Total Price:</span>
          <span class="calculator-price-value">${this.formatMoney(totalPrice)}</span>
        </div>
      `;
      
      if (savings > 0) {
        html += `
          <div class="calculator-savings">
            <span class="calculator-savings-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <circle cx="12" cy="12" r="10"></circle>
                <polyline points="8 12 12 16 16 12"></polyline>
                <line x1="12" y1="8" x2="12" y2="16"></line>
              </svg>
              Total Savings:
            </span>
            <span>${this.formatMoney(savings)}</span>
          </div>
        `;
      }
      
      this.priceBreakdownContainer.innerHTML = html;
    }
    
    renderActiveDiscounts() {
      if (!this.pricing) return;
      
      const { breakdown } = this.pricing;
      const hasActiveDiscounts = breakdown.baseTier.type !== 'none' || 
                               breakdown.addonBreakdown.some(addon => addon.tier.type !== 'none');
      
      if (!hasActiveDiscounts) {
        this.activeDiscountsContainer.classList.add('hidden');
        return;
      }
      
      let html = `
        <div class="calculator-active-discounts-header">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <polyline points="23 6 13.5 15.5 8.5 10.5 1 18"></polyline>
            <polyline points="17 6 23 6 23 12"></polyline>
          </svg>
          <span>Volume Discounts Active!</span>
        </div>
        <div class="calculator-active-discounts-list">
      `;
      
      if (breakdown.baseTier.type !== 'none') {
        html += `
          <div class="calculator-active-discounts-item">
            Base Price: ${this.getTierDescription(breakdown.baseTier)}
          </div>
        `;
      }
      
      breakdown.addonBreakdown.forEach(addon => {
        if (addon.tier.type !== 'none') {
          html += `
            <div class="calculator-active-discounts-item">
              ${addon.selectedValue}: ${this.getTierDescription(addon.tier)}
            </div>
          `;
        }
      });
      
      html += '</div>';
      
      this.activeDiscountsContainer.innerHTML = html;
      this.activeDiscountsContainer.classList.remove('hidden');
    }
    
    renderTierTables() {
      // Render base price tiers
      this.renderBaseTiersTable();
      
      // Render addon tiers
      this.renderAddonTiersAccordion();
    }
    
    renderBaseTiersTable() {
      if (!this.baseTiers || !this.baseTiers.length) {
        this.baseTiersBody.innerHTML = `
          <tr>
            <td colspan="4" class="text-center">No tier pricing available for this product.</td>
          </tr>
        `;
        return;
      }
      
      let html = '';
      
      this.baseTiers.forEach(tier => {
        // Updated to handle "no max price"
        const isNoMaxPrice = tier.max_qty === -1 || tier.max_qty === 999999999;
        const isCurrentTier = this.quantity >= tier.min_qty && 
                             (isNoMaxPrice || this.quantity <= tier.max_qty);
        
        const unitPrice = tier.type === 'fixed' ? tier.value : 
                          tier.type === 'percentage' ? this.basePrice * (1 - tier.value / 100) :
                          tier.type === 'flat' ? this.basePrice - tier.value :
                          this.basePrice;
        const savings = this.basePrice - unitPrice;
        
        // Format the quantity range to show "X+" for unlimited upper bounds
        const quantityRange = isNoMaxPrice ? 
          `${this.formatNumber(tier.min_qty)}+ units` : 
          `${this.formatNumber(tier.min_qty)} - ${this.formatNumber(tier.max_qty)} units`;
        
        html += `
          <tr class="${isCurrentTier ? 'current-tier' : ''}">
            <td>
              <div style="display: flex; align-items: center; gap: 8px;">
                ${isCurrentTier ? `
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="color: var(--calculator-primary-blue);">
                    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                    <polyline points="22 4 12 14.01 9 11.01"></polyline>
                  </svg>
                ` : ''}
                ${quantityRange}
              </div>
            </td>
            <td>
              <span class="calculator-tier-badge ${isCurrentTier ? 'current' : ''}">
                ${this.formatTierForTable(tier)}
              </span>
            </td>
            <td>
              ${this.formatMoney(unitPrice)}
            </td>
            <td style="text-align: right;">
              ${savings > 0 ? 
                `<span class="calculator-tier-savings">${this.formatMoney(savings)}</span>` : 
                '<span style="color: var(--calculator-gray-400);">-</span>'}
            </td>
          </tr>
        `;
      });
      
      this.baseTiersBody.innerHTML = html;
    }
    
    renderAddonTiersAccordion() {
      if (!this.addons || !this.addons.length) {
        this.addonTiersContainer.innerHTML = '<p>No addon options available for this product.</p>';
        return;
      }
      
      let html = '';
      
      this.addons.forEach(addon => {
        const hasAddonWithPrice = addon.values.some(value => value.price_addon > 0 && value.price_tiers && value.price_tiers.length);
        
        if (!hasAddonWithPrice) return;
        
        html += `
          <div class="calculator-accordion-item">
            <div class="calculator-accordion-header">
              <div class="calculator-accordion-title">
                ${addon.label}
              </div>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="calculator-accordion-icon">
                <polyline points="6 9 12 15 18 9"></polyline>
              </svg>
            </div>
            <div class="calculator-accordion-content">
        `;
        
        addon.values.filter(value => value.price_addon > 0 && value.price_tiers && value.price_tiers.length).forEach(value => {
          html += `
            <div class="calculator-addon-option">
              <div class="calculator-addon-option-header">
                <span class="calculator-addon-option-title">${value.label}</span>
                <span class="calculator-tier-badge">Base: ${this.formatMoney(value.price_addon)}</span>
              </div>
              
              <div class="calculator-tier-table-wrapper">
                <table class="calculator-tier-table">
                  <thead>
                    <tr>
                      <th style="width: 30%;">Quantity</th>
                      <th style="width: 30%;">Discount</th>
                      <th style="width: 20%;">Final Price</th>
                      <th style="width: 20%; text-align: right;">Savings</th>
                    </tr>
                  </thead>
                  <tbody>
          `;
          
          if (value.price_tiers && value.price_tiers.length) {
            value.price_tiers.forEach(tier => {
              // Updated to handle "no max price"
              const isNoMaxPrice = tier.max_qty === -1 || tier.max_qty === 999999999;
              const isCurrentTier = this.quantity >= tier.min_qty && 
                                   (isNoMaxPrice || this.quantity <= tier.max_qty);
              
              const finalPrice = tier.type === 'fixed' ? tier.value : 
                                tier.type === 'percentage' ? value.price_addon * (1 - tier.value / 100) :
                                tier.type === 'flat' ? Math.max(value.price_addon - tier.value, 0) :
                                value.price_addon;
              const savings = value.price_addon - finalPrice;
              
              // Format the quantity range to show "X+" for unlimited upper bounds
              const quantityRange = isNoMaxPrice ? 
                `${this.formatNumber(tier.min_qty)}+` : 
                `${this.formatNumber(tier.min_qty)}-${this.formatNumber(tier.max_qty)}`;
              
              html += `
                <tr class="${isCurrentTier ? 'current-tier' : ''}">
                  <td>
                    <div style="display: flex; align-items: center; gap: 8px;">
                      ${isCurrentTier ? `
                        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="color: var(--calculator-success-green);">
                          <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                          <polyline points="22 4 12 14.01 9 11.01"></polyline>
                        </svg>
                      ` : ''}
                      ${quantityRange}
                    </div>
                  </td>
                  <td>
                    <span class="calculator-tier-badge ${isCurrentTier ? 'current' : ''}">
                      ${this.formatTierForTable(tier)}
                    </span>
                  </td>
                  <td>
                    ${this.formatMoney(finalPrice)}
                  </td>
                  <td style="text-align: right;">
                    ${savings > 0 ? 
                      `<span class="calculator-tier-savings">${this.formatMoney(savings)}</span>` : 
                      '<span style="color: var(--calculator-gray-400);">-</span>'}
                  </td>
                </tr>
              `;
            });
          } else {
            html += `
              <tr>
                <td colspan="4" style="text-align: center;">No tier pricing available for this option.</td>
              </tr>
            `;
          }
          
          html += `
                  </tbody>
                </table>
              </div>
            </div>
          `;
        });
        
        html += `
            </div>
          </div>
        `;
      });
      
      this.addonTiersContainer.innerHTML = html;
      
      // Setup accordion functionality
      this.setupAccordions();
    }
    
    setupAccordions() {
      const accordionHeaders = document.querySelectorAll('.calculator-accordion-header');
      
      accordionHeaders.forEach(header => {
        header.addEventListener('click', () => {
          const accordionItem = header.closest('.calculator-accordion-item');
          accordionItem.classList.toggle('open');
        });
      });
    }
    
    setupEventListeners() {
      // Quantity input
      if (this.quantitySelect) {
        // Add click event to select all text when clicking the input
        this.quantitySelect.addEventListener('click', (e) => {
          // Select all text in the input to make it easier to replace
          e.target.select();
        });
        
        // Use change event instead of input to let users type freely
        this.quantitySelect.addEventListener('change', (e) => {
          let value = parseInt(e.target.value);
          
          // Just validate if it's a number, allow any value
          if (isNaN(value) || value < 1) {
            value = 1;
            e.target.value = value;
          }
          
          this.handleQuantityChange(value);
          this.validateQuantity(value);
        });
        
        // Add keydown event to handle Enter key
        this.quantitySelect.addEventListener('keydown', (e) => {
          if (e.key === 'Enter') {
            e.preventDefault();
            let value = parseInt(e.target.value);
            
            if (isNaN(value) || value < 1) {
              value = 1;
              e.target.value = value;
            }
            
            this.handleQuantityChange(value);
            this.validateQuantity(value);
            e.target.blur(); // Remove focus from the input
          }
        });
        
        // Add blur event to validate when leaving the field
        this.quantitySelect.addEventListener('blur', (e) => {
          let value = parseInt(e.target.value);
          
          if (isNaN(value) || value < 1) {
            value = 1;
            e.target.value = value;
            this.handleQuantityChange(value);
          }
          
          this.validateQuantity(value);
        });
      }
      
      // View tiers button
      if (this.viewTiersButton) {
        this.viewTiersButton.addEventListener('click', () => {
          this.openPricingModal();
        });
      }
      
      // Modal close button
      if (this.modalClose) {
        this.modalClose.addEventListener('click', () => {
          this.closePricingModal();
        });
      }
      
      // Modal tabs
      if (this.modalTabs) {
        this.modalTabs.forEach(tab => {
          tab.addEventListener('click', () => {
            const tabName = tab.dataset.tab;
            this.switchTab(tabName);
          });
        });
      }
      
      // Add to cart button
      if (this.addToCartButton) {
        this.addToCartButton.addEventListener('click', () => {
          // Check if the quantity is valid before adding to cart
          if (this.validateQuantity(this.quantity)) {
            this.handleAddToCart();
          } else {
            // Scroll to the quantity input to highlight the issue
            this.quantitySelect.scrollIntoView({ behavior: 'smooth', block: 'center' });
            this.quantitySelect.focus();
            
            // Briefly flash the MOQ notice to draw attention
            const moqNotice = document.getElementById('calculator-moq-notice');
            if (moqNotice) {
              moqNotice.classList.add('calculator-moq-flash');
              setTimeout(() => {
                moqNotice.classList.remove('calculator-moq-flash');
              }, 1000);
            }
          }
        });
      }
      
      // Get quote button
      if (this.getQuoteButton) {
        this.getQuoteButton.addEventListener('click', () => {
          // Check if the quantity is valid before opening the inquiry modal
          if (this.validateQuantity(this.quantity)) {
            this.openInquiryModal();
          } else {
            // Scroll to the quantity input to highlight the issue
            this.quantitySelect.scrollIntoView({ behavior: 'smooth', block: 'center' });
            this.quantitySelect.focus();
            
            // Briefly flash the MOQ notice to draw attention
            const moqNotice = document.getElementById('calculator-moq-notice');
            if (moqNotice) {
              moqNotice.classList.add('calculator-moq-flash');
              setTimeout(() => {
                moqNotice.classList.remove('calculator-moq-flash');
              }, 1000);
            }
          }
        });
      }
      
      // Inquiry modal close
      if (this.inquiryClose) {
        this.inquiryClose.addEventListener('click', () => {
          this.closeInquiryModal();
        });
      }
      
      // Inquiry form submit
      if (this.inquiryForm) {
        this.inquiryForm.addEventListener('submit', (e) => {
          if (DEBUG) {
            console.log('Form submission started...');
          }
          
          // Only prevent default if validation fails
          if (!this.handleInquirySubmit()) {
            e.preventDefault();
            if (DEBUG) {
              console.log('Form validation failed, submission prevented');
            }
            return false;
          }
          
          if (DEBUG) {
            console.log('Form is valid, submitting to Shopify contact endpoint');
          }
          
          // Allow form submission to proceed with Shopify's default handling
          return true;
        });
      }
      
      // Close modals when clicking overlay
      document.addEventListener('click', (e) => {
        if (e.target.classList.contains('calculator-modal-overlay')) {
          this.closePricingModal();
          this.closeInquiryModal();
        }
      });
    }
    
    openPricingModal() {
      this.renderTierTables();
      this.pricingModal.classList.remove('hidden');
      document.body.style.overflow = 'hidden';
    }
    
    closePricingModal() {
      this.pricingModal.classList.add('hidden');
      document.body.style.overflow = '';
    }
    
    switchTab(tabName) {
      // Update tab buttons
      this.modalTabs.forEach(tab => {
        if (tab.dataset.tab === tabName) {
          tab.classList.add('active');
        } else {
          tab.classList.remove('active');
        }
      });
      
      // Update tab contents
      this.tabContents.forEach(content => {
        if (content.id === `calculator-${tabName}-tab`) {
          content.classList.add('active');
        } else {
          content.classList.remove('active');
        }
      });
    }
    
    openInquiryModal() {
      // Update summary in the inquiry modal
      this.quantitySummary.textContent = this.formatNumber(this.quantity);
      this.priceSummary.textContent = this.formatMoney(this.pricing.totalPrice);
      
      // Update hidden fields with product and pricing details
      document.getElementById('inquiry-product-quantity').value = this.quantity.toString();
      document.getElementById('inquiry-product-unit-price').value = this.formatMoney(this.pricing.unitPrice);
      document.getElementById('inquiry-product-price').value = this.formatMoney(this.pricing.totalPrice);
      
      // Format selected options
      const optionsFormatted = Object.entries(this.selectedOptions)
        .map(([key, value]) => `${key}: ${value}`)
        .join(', ');
      document.getElementById('inquiry-product-options').value = optionsFormatted || 'None';
      
      // Create detailed price breakdown - REMOVED since we have formatted content
      // document.getElementById('inquiry-price-breakdown').value = priceBreakdown;
      
      // Create formatted email content for better presentation
      this.createFormattedEmailContent();
      
      this.inquiryModal.classList.remove('hidden');
      document.body.style.overflow = 'hidden';
    }
    
    createFormattedEmailContent() {
      // Create a simple, clean formatted email content without ASCII tables
      let formattedContent = `
============================================================
                    QUOTE REQUEST DETAILS
============================================================

PRODUCT INFORMATION:
------------------------------------------------------------
Product Name:        ${this.productTitle}
Product ID:          ${this.productId}
Requested Quantity:  ${this.formatNumber(this.quantity)} units

PRICING BREAKDOWN:
------------------------------------------------------------
Base Product Price:  ${this.formatMoney(this.basePrice)}`;

      // Only show discount if there's actually a discount
      if (this.pricing.breakdown.baseTier.type !== 'none') {
        formattedContent += `
Base Discount:       ${this.getTierDescription(this.pricing.breakdown.baseTier)}
Final Base Price:    ${this.formatMoney(this.pricing.breakdown.discountedBase)}`;
      } else {
        formattedContent += `
Final Base Price:    ${this.formatMoney(this.pricing.breakdown.discountedBase)}`;
      }

      // Add addon options if any
      if (this.pricing.breakdown.addonBreakdown && this.pricing.breakdown.addonBreakdown.length > 0) {
        formattedContent += `

SELECTED OPTIONS:
------------------------------------------------------------`;
        
        this.pricing.breakdown.addonBreakdown.forEach(addon => {
          formattedContent += `
${addon.optionLabel}: ${addon.selectedValue}
  - Original Price: ${this.formatMoney(addon.originalPrice)}`;
          
          if (addon.tier.type !== 'none') {
            formattedContent += `
  - Discount Applied: ${this.getTierDescription(addon.tier)}`;
          }
          
          formattedContent += `
  - Final Price: ${this.formatMoney(addon.discountedPrice)}`;
        });
      }

      // Add pricing summary
      formattedContent += `

PRICING SUMMARY:
------------------------------------------------------------
Base Price per Unit:     ${this.formatMoney(this.pricing.breakdown.discountedBase)}
Add-ons Price per Unit:  ${this.formatMoney(this.pricing.breakdown.totalAddonPrice)}
------------------------------------------------------------
Final Unit Price:        ${this.formatMoney(this.pricing.unitPrice)}
Quantity:                ${this.formatNumber(this.quantity)}
------------------------------------------------------------
TOTAL PRICE:             ${this.formatMoney(this.pricing.totalPrice)}`;

      if (this.pricing.savings > 0) {
        formattedContent += `

SAVINGS:
------------------------------------------------------------
Total Amount Saved:      ${this.formatMoney(this.pricing.savings)}`;
      }

      formattedContent += `

VOLUME DISCOUNT STATUS:
------------------------------------------------------------`;

      // Add volume discount info
      if (this.pricing.breakdown.baseTier.type !== 'none') {
        formattedContent += `
✓ Base Price Discount Applied: ${this.getTierDescription(this.pricing.breakdown.baseTier)}`;
      } else {
        formattedContent += `
• Base Price: Standard pricing (no volume discount available)`;
      }

      let hasAddonDiscounts = false;
      this.pricing.breakdown.addonBreakdown.forEach(addon => {
        if (addon.tier.type !== 'none') {
          formattedContent += `
✓ ${addon.optionLabel} Discount Applied: ${this.getTierDescription(addon.tier)}`;
          hasAddonDiscounts = true;
        }
      });

      if (!hasAddonDiscounts && this.pricing.breakdown.addonBreakdown.length > 0) {
        formattedContent += `
• Add-on Options: Standard pricing (no volume discounts available)`;
      }

      formattedContent += `

============================================================
INTERNAL NOTE: This quote was automatically generated by the 
pricing calculator. Customer has requested a custom quote 
based on the selections above. Please review and respond.
============================================================`;

      // Set the formatted content to the hidden field
      document.getElementById('inquiry-formatted-content').value = formattedContent;
    }
    
    closeInquiryModal() {
      this.inquiryModal.classList.add('hidden');
      document.body.style.overflow = '';
    }
    
    handleAddToCart() {
      if (!this.pricing) return;
      
      // Prepare line item properties
      const properties = {};
      
      // Add selected options as properties
      for (const [key, value] of Object.entries(this.selectedOptions)) {
        properties[key] = value;
      }
      
      // Add pricing information
      properties['Quantity'] = this.quantity.toString();
      properties['Base Tier'] = `${this.pricing.breakdown.baseTier.type} @ ${this.pricing.breakdown.baseTier.type === 'percentage' ? 
                              this.pricing.breakdown.baseTier.value + '%' : 
                              this.formatMoney(this.pricing.breakdown.baseTier.value)}`;
      properties['Final Unit Price'] = this.formatMoney(this.pricing.unitPrice);
      properties['Final Total Price'] = this.formatMoney(this.pricing.totalPrice);
      
      // Add individual addon tier info
      this.pricing.breakdown.addonBreakdown.forEach(addon => {
        properties[`${addon.optionLabel} Tier`] = `${addon.tier.type} @ ${addon.tier.type === 'percentage' ? 
                                              addon.tier.value + '%' : 
                                              this.formatMoney(addon.tier.value)}`;
        properties[`${addon.optionLabel} Final Price`] = this.formatMoney(addon.discountedPrice);
      });
      
      // Add to cart using Shopify AJAX API
      const addToCartData = {
        items: [{
          id: this.getSelectedVariantId(),
          quantity: this.quantity,
          properties: properties
        }]
      };
      
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(addToCartData)
      })
      .then(response => response.json())
      .then(data => {
        if (data.status && data.status !== 200) {
          console.error('Error adding to cart:', data);
          alert('Error adding to cart: ' + data.description);
        } else {
          // Success - refresh cart or show confirmation
          if (typeof window.refreshCart === 'function') {
            window.refreshCart();
          } else {
            window.location.href = '/cart';
          }
        }
      })
      .catch(error => {
        console.error('Error adding to cart:', error);
        alert('Error adding to cart. Please try again.');
      });
    }
    
    getSelectedVariantId() {
      // Try to get the selected variant ID from the form
      const productForm = document.querySelector('form[action="/cart/add"]');
      if (productForm) {
        const variantInput = productForm.querySelector('input[name="id"]');
        if (variantInput) {
          return variantInput.value;
        }
        
        const variantSelect = productForm.querySelector('select[name="id"]');
        if (variantSelect) {
          return variantSelect.value;
        }
      }
      
      // Fallback: Try to get from URL
      const urlParams = new URLSearchParams(window.location.search);
      const variantId = urlParams.get('variant');
      if (variantId) {
        return variantId;
      }
      
      // Final fallback: Get first available variant
      return this.productId; // This is likely the product ID, not variant ID
    }
    
    handleInquirySubmit() {
      if (DEBUG) {
        console.log('handleInquirySubmit called');
      }
      
      // Just do some basic validation before the form submits
      const name = document.getElementById('inquiry-name').value;
      const email = document.getElementById('inquiry-email').value;
      const message = document.getElementById('inquiry-message').value;
      
      if (DEBUG) {
        console.log('Form data:', { name, email, message: message.substring(0, 50) + '...' });
      }
      
      if (!name || !email || !message) {
        alert('Please fill out all required fields.');
        if (DEBUG) {
          console.log('Validation failed: missing required fields');
        }
        return false; // Prevent form submission
      }
      
      if (DEBUG) {
        console.log('Validation passed, allowing form submission');
      }
      
      // Let the form submit naturally to Shopify's contact endpoint
      // The form is already set up with the proper attributes for Shopify's hCaptcha
      return true;
    }
    

    
    // Helper Methods
    formatMoney(amount) {
      return `${this.currency}${amount.toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })}`;
    }
    
    formatNumber(num) {
      return num.toLocaleString();
    }
    
    getTierDescription(tier) {
      if (tier.type === 'none') return 'Standard Price';
      if (tier.type === 'percentage') return `${tier.value}% OFF`;
      if (tier.type === 'flat') return `${this.formatMoney(tier.value)} OFF per unit`;
      if (tier.type === 'fixed') return `${this.formatMoney(tier.value)} per unit`;
      return 'Custom pricing';
    }
    
    formatTierForTable(tier) {
      if (tier.type === 'none') return 'No Discount';
      if (tier.type === 'percentage') return `${tier.value}% Discount`;
      if (tier.type === 'flat') return `${this.formatMoney(tier.value)} Off Per Unit`;
      if (tier.type === 'fixed') return `Fixed Price: ${this.formatMoney(tier.value)}`;
      return 'Custom';
    }
  }
  
  // Initialize the calculator
  new BulkPricingCalculator();
});
